import { ValueOf } from "utils/typeCheck.utils";

export const TOGGLE_SIZE = {
  S: "small",
  M: "medium",
  L: "large",
} as const;

export interface CustomToggleProps {
  /** Current state of the toggle - true for enabled/on, false for disabled/off */
  checked: boolean;
  /** Callback function called when toggle state changes */
  onChange?: (checked: boolean) => void;
  /** Disables the toggle when true */
  disabled?: boolean;
  /** Additional CSS classes to apply */
  className?: string;
  /** Label text to display next to the toggle */
  label?: string;
  /** Size variant of the toggle */
  size?: ValueOf<typeof TOGGLE_SIZE>;
}
